import { GET_BUYER_DATA } from "@/gql/group";
import { getApolloData } from "@/utils/apollo/get-data";
import { logger } from "@/utils/logger";
import { removeTypename } from "./removeTypeName";

export type BuyerDetails = {
	id: string;
	identifier: string;
	relationship: string;
	name: string;
	designation: string;
	members: {
		id: string;
		identifier: string;
		name: string;
		designation: string;
	}[];
	buyerProjects: {
		id: string;
		interestedInProject: boolean;
		visitRequested: boolean;
		notes: string;
		locality: string;
		processDetails: { process: string; status: string; stage: string }[];
		project: { id: string };
	}[];
	projectVisitC2c: {
		project: { id: string };
	}[];
	buyerUnits: {
		id: string;
		unit: { _id: string };
		processDetails: { process: string; status: string; stage: string }[];
	}[];
};

export type GroupActivity = {
	projectVisitC2c: {
		project: { id: string };
	}[];
};

export async function getBuyerData(params: {
	id: string;
}): Promise<{ data: BuyerDetails | null; error: string | null }> {
	const { id } = params;

	const { data, error } = await getApolloData<{
		user: {
			groupOne: BuyerDetails;
		};
		requests: {
			groupActivity: GroupActivity;
		};
	}>({
		query: GET_BUYER_DATA,
		variables: {
			params: {
				groupOne: { id },
			},
			requestsParams2: {
				groupActivity: { groupId: id },
			},
		},
		fetchPolicy: "cache-first",
	});
	if (error) {
		logger.error("Failed to fetch group data", {
			method: "getBuyerData",
			query: "GET_BUYER_DATA (user.groupOne + requests.groupActivity)",
			params,
			error,
		});
		return { data: null, error: "Failed to fetch group data" };
	}

	if (!data) {
		return { data: null, error: "No group data found" };
	}

	const groupOne = data?.user?.groupOne ? (removeTypename(data?.user?.groupOne) as unknown as BuyerDetails) : null;
	// Merge projectVisitC2c from requests.groupActivity into groupOne
	if (groupOne && data?.requests?.groupActivity) {
		const groupActivity = removeTypename(data.requests.groupActivity) as GroupActivity;
		groupOne.projectVisitC2c = groupActivity?.projectVisitC2c || [];
	}

	return { data: groupOne, error: null };
}
